<div class="container-fluid row">
    <div class="col-12 title">Collectibles</div>
</div>
<app-asset-listing [params]="params" [currentPage]="'browse'"></app-asset-listing>
